import styled from 'styled-components';
import theme from 'configs/theme';

export default styled.div`
  height: 100vh;
  min-height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
  background-color: ${theme.palette.primaryColor};

  .main {
    padding: 20px;
  }

  img {
    width: 100%;
  }

  .text-div {
    margin: 20px 0;

    > div {
      line-height: 1;
      font-size: 30px;
    }

    > div:first-child {
      font-size: 80px;
    }
  }
`;
